// Remove .00 from product compare price
function stripZeroCents() {
  document.querySelectorAll('compare-at-price, sale-price').forEach(el => {
    el.childNodes.forEach(node => {
      if (node.nodeType === Node.TEXT_NODE) {
        node.textContent = node.textContent.replace(/\.00$/, '');
      }
    });
  });
}

stripZeroCents();

const observer = new MutationObserver(stripZeroCents);

document.querySelectorAll('price-list, product-rerender').forEach(el => {
  // Observe the parent of price-list, since price-list itself gets replaced
  if (el.parentElement) {
    observer.observe(el.parentElement, { childList: true, subtree: true });
  }
});

/* ==========================================================
   Hidden variant fix (UV Skinz)
   Some colorways don't come in every size. Those size variants
   are unpublished from Online Store, so the storefront treats the
   combo as nonexistent. This script:
   1. Hides size buttons that don't exist for the selected color
      (instead of showing them crossed out as "Unavailable").
      Real sold-out sizes stay visible so Back in Stock still works.
   2. When a shopper picks a color and their current size doesn't
      exist in it, switches to the closest size that does, before
      the theme updates. Photos, SKU, price and the ATC button then
      update normally.
   3. Keeps size buttons in true size order (XS before S, 0/3m
      before 3/6m). Unpublished first variants can make Shopify
      render sizes out of order.
   ========================================================== */
(() => {
  /* ---------- Size ranking ---------- */
  const LETTERS = ['XXS', 'XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL'];

  // Returns [group, value] or null if the size can't be ranked.
  // group 0 = age/number based (months, T sizes, numeric), group 1 = letter sizes
  const sizeKey = raw => {
    const v = String(raw).trim().toUpperCase();
    let m;
    if ((m = v.match(/^(XXS|XS|XXL|XL|2XL|3XL|4XL|5XL|S|M|L)\b/))) {
      return [1, LETTERS.indexOf(m[1] === 'XXL' ? '2XL' : m[1])];
    }
    if ((m = v.match(/^(\d+)\s*\/\s*\d+\s*M\b/))) return [0, +m[1]];          // 0/3m, 12/18m
    if ((m = v.match(/^(\d+)T\b/))) return [0, +m[1] * 12];                  // 2T, 2T/3T, 4T/5
    if ((m = v.match(/^(\d+)(?:X(\d+))?/))) return [0, +m[1] * 12 + (m[2] ? +m[2] / 100 : 0)]; // 5, 6/8, 32x34
    return null;
  };
  const compareKeys = (a, b) => a[0] - b[0] || a[1] - b[1];

  // Sorted list of values if every value is rankable in the same group, else null
  const rankedOrder = values => {
    const keys = values.map(sizeKey);
    if (keys.some(k => !k) || new Set(keys.map(k => k[0])).size > 1) return null;
    return values
      .map((v, i) => ({ v, k: keys[i], i }))
      .sort((a, b) => compareKeys(a.k, b.k) || a.i - b.i)
      .map(x => x.v);
  };

  /* ---------- Product data ---------- */
  const cache = {};
  const load = handle => {
    if (!cache[handle]) {
      cache[handle] = fetch(`/products/${handle}.js`)
        .then(r => r.json())
        .then(p => {
          p.variants = p.variants.filter(v => v.sku !== 'DO NOT DELETE');
          // Value order per option: true size order when rankable, else Shopify's order
          p.valueOrder = p.options.map(o => {
            const values = o.values || [];
            return (/size/i.test(o.name) && rankedOrder(values)) || values;
          });
          cache[handle] = p;
          document.querySelectorAll(`variant-picker[handle="${handle}"]`).forEach(apply);
          return p;
        })
        .catch(() => { delete cache[handle]; });
    }
    return cache[handle];
  };
  const data = picker => {
    const p = cache[picker.getAttribute('handle')];
    return p && p.variants ? p : null;
  };

  /* ---------- DOM helpers ---------- */
  const labelOf = input =>
    input.id ? document.querySelector(`label[for="${CSS.escape(input.id)}"]`) : null;
  const labelText = input => {
    const label = labelOf(input);
    return label ? label.textContent.trim() : input.value;
  };
  const groupsOf = picker => {
    const radios = [...picker.querySelectorAll('input[type="radio"][data-option-position]')];
    const byName = {};
    radios.forEach(r => (byName[r.name] = byName[r.name] || []).push(r));
    return Object.values(byName);
  };
  const colorIndexOf = product => product.options.findIndex(o => /colou?r/i.test(o.name || o));
  const comboExists = (product, values) =>
    product.variants.some(v => v.options.every((o, i) => o === values[i]));
  const selectedValues = groups => groups.map(g => {
    const r = g.find(x => x.checked);
    return r ? labelText(r) : null;
  });
  const valid = (product, groups) =>
    colorIndexOf(product) >= 0 && groups.length === product.options.length;

  /* ---------- 3. Size order ---------- */
  function sortSizes(product, groups) {
    product.options.forEach((o, i) => {
      if (!/size/i.test(o.name)) return;
      const order = product.valueOrder[i];
      const g = groups[i];
      const pairs = g.map(r => ({ r, l: labelOf(r) }));
      const parent = g[0] && g[0].parentElement;
      if (!parent || pairs.some(p => !p.l || p.r.parentElement !== parent || p.l.parentElement !== parent)) return;

      const pos = v => { const n = order.indexOf(v); return n < 0 ? 999 : n; };
      const sorted = pairs.slice().sort((a, b) => pos(labelText(a.r)) - pos(labelText(b.r)));
      if (sorted.every((p, n) => p === pairs[n])) return; // already in order
      sorted.forEach(p => parent.append(p.r, p.l));
    });
  }

  /* ---------- 1. Hide sizes that don't exist ---------- */
  function hideMissing(product, groups) {
    const ci = colorIndexOf(product);
    const selected = selectedValues(groups);
    groups.forEach((g, i) => {
      if (i === ci) return; // never hide color swatches
      g.forEach(r => {
        const values = selected.slice();
        values[i] = labelText(r);
        const label = labelOf(r);
        if (label) label.hidden = !comboExists(product, values);
      });
    });
  }

  function apply(picker) {
    const product = data(picker);
    if (!product) return;
    const groups = groupsOf(picker);
    if (!valid(product, groups)) return;
    sortSizes(product, groups);
    hideMissing(product, groups);
  }

  /* ---------- 2. Closest size on color change ---------- */
  // Capture phase: runs before the theme's own change handler
  document.addEventListener('change', e => {
    const input = e.target;
    if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;
    const picker = input.closest('variant-picker[handle]');
    if (!picker) return;
    const product = data(picker);
    if (!product) return;

    const groups = groupsOf(picker);
    if (!valid(product, groups)) return;
    const ci = colorIndexOf(product);
    if (!groups[ci].includes(input)) return;

    const selected = selectedValues(groups);
    if (comboExists(product, selected)) return;

    // Distance from the current selection, measured in steps of the size order
    const distance = v => v.options.reduce((sum, val, i) => {
      if (i === ci || selected[i] == null) return sum;
      const order = product.valueOrder[i];
      const a = order.indexOf(val), b = order.indexOf(selected[i]);
      return sum + (a < 0 || b < 0 ? 0 : Math.abs(a - b) * 2 - (a > b ? 1 : 0)); // tie goes to the larger size
    }, 0);

    const inColor = product.variants.filter(v => v.options[ci] === selected[ci]);
    const pool = inColor.some(v => v.available) ? inColor.filter(v => v.available) : inColor;
    if (!pool.length) return;
    const fallback = pool.reduce((best, v) => (distance(v) < distance(best) ? v : best));

    groups.forEach((g, i) => {
      if (i === ci) return;
      const target = g.find(r => labelText(r) === fallback.options[i]);
      if (target) target.checked = true;
    });
  }, true);

  /* ---------- Run on load and whenever the theme re-renders ---------- */
  const scan = () => document.querySelectorAll('variant-picker[handle]').forEach(p => {
    load(p.getAttribute('handle'));
    apply(p);
  });
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; scan(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
  scan();
})();